import { RG_TYPE } from '../../types/rg-type.js';

const DefaultFloor = {
    type: RG_TYPE.Floor,
    modulousId: 'FPA|02|',
    size: [6, 0.1, 6],
    anchor: [0.5, 0, 0.5],
    name: 'floor',
    children: [],
    color: '#CEE9BD'
};

export { DefaultFloor };
//# sourceMappingURL=default-floor.js.map
